<template>
	<div>
		<el-drawer
			:title="`${data.assetNo} - 折旧详情`"
			:visible.sync="dialogVisible"
			size="45%"
			:close-on-click-modal="false"
			:before-close="handleClose"
			destroy-on-close>
			<div class="drawer-content">
				<!-- 标签页 -->
				<el-tabs v-model="activeName" @tab-click="handleClick">
					<el-tab-pane label="基本信息" name="1" lazy>
						<el-card class="table-card" shadow="always">
							<div slot="header" class="clearfix">
								<span>折旧信息</span>
							</div>
							<el-descriptions :column="2" border>
								<el-descriptions-item label="资产编号">
									{{ detailData.assetNo || '--' }}
								</el-descriptions-item>
								<el-descriptions-item label="资产名称">
									{{ detailData.assetName || '--' }}
								</el-descriptions-item>
								<el-descriptions-item label="所属项目">
									{{ detailData.communityName || '--' }}
								</el-descriptions-item>
								<el-descriptions-item label="资产大类">
									{{ $menu.getLabel('AssetCategory', detailData.assetCategory) || '--' }}
								</el-descriptions-item>
								<el-descriptions-item label="资产原值">
									¥{{ (detailData.originalValue || 0).toFixed(2) }}万元
								</el-descriptions-item>
								<el-descriptions-item label="当前净值">
									¥{{ (detailData.netValue || 0).toFixed(2) }}万元
								</el-descriptions-item>
								<el-descriptions-item label="预计净残值">
									¥{{ (detailData.residualValue || 0).toFixed(2) }}万元
								</el-descriptions-item>
								<el-descriptions-item label="预计使用年限">
									{{ detailData.serviceLife || detailData.depreciationYears || 0 }}年
								</el-descriptions-item>
								<el-descriptions-item label="折旧方法">
									{{ $menu.getLabel('DepreciationMethod', detailData.depreciationMethod) || '--' }}
								</el-descriptions-item>
								<el-descriptions-item label="月折旧额">
									¥{{ (detailData.monthlyDepreciation || 0).toLocaleString() }}
								</el-descriptions-item>
								<el-descriptions-item label="年折旧额">
									¥{{ (detailData.annualDepreciation || 0).toLocaleString() }}
								</el-descriptions-item>
								<el-descriptions-item label="累计折旧">
									¥{{ (detailData.accumulatedDepreciation || 0).toFixed(2) }}万元
								</el-descriptions-item>
								<el-descriptions-item label="资产净值">
									<span class="highlight">¥{{ (detailData.netValue || 0).toFixed(2) }}万元</span>
								</el-descriptions-item>
								<el-descriptions-item label="折旧状态">
									<el-tag :type="getStatusTagType(detailData.depreciationStatus)" size="small">
										{{ $menu.getLabel('DepreciationStatus', detailData.depreciationStatus) || '--' }}
									</el-tag>
								</el-descriptions-item>
								<el-descriptions-item label="计提开始日期">
									{{ detailData.depreciationStartDate || '--' }}
								</el-descriptions-item>
								<el-descriptions-item label="折旧结束日期">
									{{ detailData.depreciationEndDate || '--' }}
								</el-descriptions-item>
							</el-descriptions>
						</el-card>
					</el-tab-pane>
					<el-tab-pane label="计提记录" name="2" lazy>
						<el-card class="table-card" shadow="always">
							<el-table :data="detailData.depreciationRecordList || []" border style="width: 100%">
								<el-table-column prop="depreciationMonth" label="计提月份" width="120" />
								<el-table-column prop="depreciationAmount" label="计提金额(元)" width="150">
									<template slot-scope="scope">
										{{ scope.row.depreciationAmount || 0 }}
									</template>
								</el-table-column>
								<el-table-column prop="depreciationDate" label="计提日期" width="120" />
								<el-table-column prop="operator" label="操作人" width="120" />
								<el-table-column prop="type" label="类型" width="100">
									<template slot-scope="scope">
										<el-tag type="info" size="small">{{ scope.row.type || '--' }}</el-tag>
									</template>
								</el-table-column>
							</el-table>
						</el-card>
					</el-tab-pane>
				</el-tabs>
			</div>
		</el-drawer>
	</div>
</template>

<script>
	import { getAssetById } from '@/api/asset/assetLedgerApi';
	export default {
		name: 'AssetDepreciationDetailDrawer',
		components: {},
		props: {
			dialogVisible: Boolean,
			data: {
				type: Object,
				default: () => ({}),
			},
		},
		watch: {
			dialogVisible(val) {
				if (val) {
					this.$nextTick(() => {
						this.activeName = '1';
						this.fetchAssetDetail(this.data.id);
					});
				}
			},
		},
		data() {
			return {
				activeName: '1',
				detailData: {},
			};
		},
		computed: {
			depreciationRecordTitle() {
				const length = (this.detailData.depreciationRecordList && this.detailData.depreciationRecordList.length) || 0;
				if (length) return `计提记录(${length})`;
				return '计提记录';
			},
		},
		methods: {
			async fetchAssetDetail(id) {
				try {
					const res = await getAssetById(id);
					console.log(res, 'getAssetById');
					this.detailData = res;
				} catch (err) {
					console.log(err);
				}
			},
			handleClose() {
				this.$emit('update:dialogVisible', false);
			},
			handleClick(tab, event) {
				console.log(tab, event);
			},
			getStatusTagType(status) {
				switch (status) {
					case 'NOT_CALCULATED':
						return 'warning';
					case 'CALCULATING':
						return 'success';
					case 'STOPPED':
						return 'danger';
					default:
						return 'default';
				}
			},
		},
	};
</script>

<style scoped lang="scss">
	.drawer-content {
		padding: 10px 24px;
		color: #666;
	}

	.table-card {
		margin-bottom: 10px;
	}

	.highlight {
		color: #ff6b35;
	}
</style>
